import { APIClient } from '@/services'
import { CommunityFeed } from '@/types'
import { communityAnalytics, formatNumberToShort, shareCommunityPost } from '@/utils'
import { memo, useCallback } from 'react'
import { ActionButton } from '../../atoms/ActionButton'

const UnMemoizedShare = ({ item }: { item: CommunityFeed }) => {
  const handleShare = useCallback(async () => {
    communityAnalytics.feedActionEvent('feed_share', item)

    const shared = await shareCommunityPost(item)

    if (shared) {
      APIClient.Community.communityOperations.mutations.share(item?.id)
    }
  }, [])

  const formattedShareCount = formatNumberToShort(item?.shares)

  return (
    <ActionButton
      icon='share-fill'
      text={formattedShareCount}
      onPress={handleShare}
    />
  )
}

export const Share = memo(UnMemoizedShare, (prevProps, nextProps) => {
  return prevProps?.item?.shares === nextProps?.item?.shares
})
